import { LoadDropdown, DefaultDropdownProps } from 'framework/form';
import { ResultResourceData } from 'framework/crud';

interface BudgetDropdownProps extends DefaultDropdownProps {
  loadDataMethod: () => ResultResourceData;
  showLoader?: boolean;
}

const BudgetDropdown = (props: BudgetDropdownProps) => {
  return (
    <LoadDropdown
      mapResults={budget => ({
        value: budget.id,
        label: budget.name,
      })}
      {...props}
    />
  );
};

export default BudgetDropdown;
